import { useAppSelector } from '../hooks.ts';
import { buildSupportMailto } from '../utils/support.ts';

/** Support `mailto:` that mentions the open workspace project and version, when there is one.
 *  Built on click so the page URL and language are current. */
export function useSupportMailto(): () => string {
  const project = useAppSelector((s) => s.workspace.project);
  return () =>
    buildSupportMailto(
      project
        ? { projectName: project.name, projectId: project.id, versionId: project.activeVersionId ?? undefined }
        : {},
    );
}
